import React from 'react';
import { Link } from 'react-router-dom';
import EditableText from './EditableText';
import { Mail, Phone, Clock, MapPin } from 'lucide-react';

const ContactList = () => (
  <ul className="space-y-3 text-sm">
    <li className="flex items-start gap-3">
      <Mail size={15} className="text-red-400 mt-1 flex-shrink-0" />
      <EditableText k="footer.email" fallback="support@fatbusters.shop" className="hover:text-red-300 transition-colors" />
    </li>
    <li className="flex items-start gap-3">
      <Phone size={15} className="text-red-400 mt-1 flex-shrink-0" />
      <EditableText k="footer.phone" fallback="(03) 9355 9001" />
    </li>
    <li className="flex items-start gap-3">
      <Clock size={15} className="text-red-400 mt-1 flex-shrink-0" />
      <EditableText k="footer.hours" fallback="Mon – Fri, 9AM – 5PM AEST" className="text-slate-400" />
    </li>
    <li className="flex items-start gap-3">
      <MapPin size={15} className="text-red-400 mt-1 flex-shrink-0" />
      <EditableText k="footer.company" fallback="FAT BUSTERS" className="text-slate-400" />
    </li>
    <li>
      <Link to="/contact" className="text-red-300 hover:text-red-200 font-semibold text-sm">Get in touch →</Link>
    </li>
  </ul>
);

const LEGAL_LINKS = [
  { href: '/dosing', label: 'Dosing & Safety Guide' },
  { href: '/privacy', label: 'Privacy Policy' },
  { href: '/terms', label: 'Terms of Service' },
  { href: '/shipping', label: 'Shipping & Returns' },
  { href: '/refunds', label: 'Refund Policy' },
];

const LegalList = () => (
  <ul className="space-y-3 text-sm">
    {LEGAL_LINKS.map((l) => (
      <li key={l.label}><a href={l.href} className="hover:text-red-300 transition-colors">{l.label}</a></li>
    ))}
  </ul>
);

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0a0a0a] text-slate-300 mt-16">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
          <h4 className="text-white text-xs font-semibold tracking-[0.14em] uppercase mb-5">Contact</h4>
          <ContactList />
        </div>
        <div>
          <h4 className="text-white text-xs font-semibold tracking-[0.14em] uppercase mb-5">Legal</h4>
          <LegalList />
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-slate-500 text-center space-y-1">
          <EditableText k="footer.disclaimer" multiline as="div"
            fallback="All products are intended for in-vitro laboratory research use only. Not for human consumption. Individual results may vary." />
          <div>&copy; {year} <EditableText k="brand.name" fallback="FAT BUSTERS" />. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
